<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      let _this = this;
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          backgroundColor:'rgba(255,255,255,1)'
        },
        // legend: {
        //   data: ["新增数", "完成数"],
        //   right: 0,
        //   textStyle: {
        //     color: _this.isbig ? "#AABEFF" : "",
        //   },
        // },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "5%",
          containLabel: true,
        },

        xAxis: {
          show: true,
          type: "category",
          // boundaryGap: false,
          axisLabel: {
            interval: 0,
          },
          data: [
            "8-1",
            "8-2",
            "8-3",
            "8-4",
            "8-5",
            "8-6",
            "8-7",
            "8-8",
            "8-9",
            "8-10",
            "8-11",
            "8-12",
            "8-13",
            "8-14",
            "8-15",
            "8-16",
            "8-17",
            "8-18",
            "8-19",
            "8-20",
            "8-21",
            "8-22",
            "8-23",
            "8-24",
            "8-25",
            "8-26",
            "8-27",
            "8-28",
            "8-29",
            "8-30",
          ],
        },
        yAxis: {
          type: "value",
          splitArea: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "#333",
          },
          splitLine: {
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [
          {
            name: "新增数",
            type: "line",
            stack: "总量",
            data: [
              120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 230,
              210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90,
              230, 210, 230, 210,
            ],
            smooth: 0,
          },
          // {
          //   name: "完成数",
          //   type: "line",
          //   stack: "总量",
          //   data: [220, 182, 191, 234, 290, 330, 310],
          //   smooth: 0,
          // },
        ],
      });
    },
  },
};
</script>
